export function IdleWarning({ countdown, onStay, onLogout }) {
  return (
    <div className="fixed inset-0 z-50 bg-on-background/70 flex items-center justify-center p-4">
      <div className="w-full max-w-[400px] bg-surface border-4 border-on-background p-8 flex flex-col items-center gap-5 text-center"
        style={{ boxShadow: '8px 8px 0px 0px var(--neo-border-color)' }}>
        <div className="w-14 h-14 bg-primary-fixed border-4 border-on-background flex items-center justify-center">
          <span className="material-symbols-outlined text-[28px]" style={{ fontVariationSettings: "'FILL' 1" }}>timer</span>
        </div>
        <div>
          <h2 className="font-extrabold text-[22px] uppercase tracking-tight">Session Expiring</h2>
          <p className="text-sm text-on-surface-variant mt-1">Auto-logout in <strong className="text-error">{countdown}s</strong> due to inactivity</p>
        </div>
        <div className="flex gap-3 w-full">
          <button onClick={onStay} className="flex-1 py-3 bg-primary-container text-on-primary-fixed font-bold uppercase text-sm border-4 border-on-background" style={{ boxShadow: '3px 3px 0px 0px var(--neo-border-color)' }}>Stay Logged In</button>
          <button onClick={onLogout} className="flex-1 py-3 bg-surface text-on-surface font-bold uppercase text-sm border-4 border-on-background" style={{ boxShadow: '3px 3px 0px 0px var(--neo-border-color)' }}>Log Out</button>
        </div>
      </div>
    </div>
  )
}
